import React from "react";
import "./Shimmer.css";
import { Grid } from "@mui/material";

// Generic Shimmer Wrapper Component
export const ShimmerWrapper = ({ children, style }) => {
  return (
    <div className="shimmer-wrapper" style={style}>
      {children}
      <div className="shimmer"></div>
    </div>
  );
};

export const NeuroShimmer = ({ count }) => {
  return Array.from({ length: count }).map((_, index) => (
    <Grid item xs={12} sm={6} md={3} key={index}>
      <div className="neuro-product-card neuro-shimmer-card">
        <div className="neuro-shimmer-img-wrap">
          <div className="shimmer-placeholder-neuro neuro-shimmer-img" />
        </div>
        <div className="neuro-shimmer-text-wrap">
          <div className="shimmer-placeholder-neuro neuro-shimmer-title" />
          <div className="shimmer-placeholder-neuro neuro-shimmer-subtitle" />
        </div>
      </div>
    </Grid>
  ));
};

export const ProductDetailShimmer = () => {
  return (
    <div className="common-sec product-detail-sec">
      <div className="product-detail-card product-detail-shimmer-card">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <div className="product-detail-image-wrap product-detail-shimmer-image">
              <div className="shimmer-placeholder-neuro" />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="product-detail-shimmer-info">
              <div className="shimmer-placeholder-neuro product-detail-shimmer-title" />
              <div className="shimmer-placeholder-neuro product-detail-shimmer-subtitle" />
              <div className="shimmer-placeholder-neuro product-detail-shimmer-line" />
              <div className="shimmer-placeholder-neuro product-detail-shimmer-line product-detail-shimmer-line-short" />
              <div className="shimmer-placeholder-neuro product-detail-shimmer-line" />
              <div className="shimmer-placeholder-neuro product-detail-shimmer-btn" />
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="range-products-section">
        <div className="shimmer-placeholder-neuro range-products-shimmer-title" />
        <Grid container spacing={2} justifyContent="center" className="range-products-grid">
          {Array.from({ length: 6 }).map((_, index) => (
            <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
              <div className="shimmer-placeholder-neuro range-product-shimmer" />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export const CareerShimmer = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="career-shimmer-wrap"
          aria-hidden="true"
        >
          <div className="career-shimmer-content">
            <div className="career-shimmer-line-title shimmer-line" />
            <div className="career-shimmer-line-exp shimmer-line" />
            <div className="career-shimmer-line-skill shimmer-line" />
          </div>
          <div className="career-shimmer-btn shimmer-line" />
        </div>
      ))}
    </>
  );
};
